import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

export default function VersionsPanel({ app }) {
  const [rows, setRows] = useState([]);
  const [note, setNote] = useState("");
  const [cmp, setCmp] = useState(null);
  const load = () => api.get(`/applications/${app.id}/versions`).then(({ data }) => setRows(data));
  useEffect(() => {
    load();
  }, [app.id]); // eslint-disable-line react-hooks/exhaustive-deps
  const save = async () => {
    try {
      await api.post(`/applications/${app.id}/versions`, { note });
      setNote("");
      load();
      toast.success("Version saved");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const compare = async (vid) => {
    const { data } = await api.get(`/applications/${app.id}/compare`, { params: { a: vid, b: "current" } });
    setCmp(data);
  };
  return (
    <div className="grid gap-6 lg:grid-cols-3">
      <section className="card p-6" data-testid="versions-panel">
        <h2 className="font-semibold text-[#0B192C]">Versions</h2>
        <div className="mt-3 flex gap-2"><input aria-label="Version note" data-testid="version-note-input" className="input" placeholder="Note (optional)" value={note} onChange={(e) => setNote(e.target.value)} /><button onClick={save} data-testid="version-save-button" className="btn-teal btn-sm">Save</button></div>
        <ul className="mt-4 divide-y divide-slate-100">
          {rows.map((v) => (
            <li key={v.id} className="flex items-center justify-between py-2 text-sm">
              <span><b>v{v.number}</b> {v.note} <span className="block text-xs text-slate-500">{v.by} · {fmtDateTime(v.at)}</span></span>
              <button onClick={() => compare(v.id)} data-testid={`compare-version-${v.number}`} className="btn-ghost btn-sm">Compare</button>
            </li>
          ))}
        </ul>
      </section>
      <section className="card p-6 lg:col-span-2" data-testid="compare-view">
        {!cmp ? <p className="text-sm text-slate-500">Choose a version to compare with the current draft.</p> : (
          <>
            <h2 className="font-semibold text-[#0B192C]">v{cmp.a} → current</h2>
            <div className="mt-4 space-y-5">
              {cmp.sections.map((s) => (
                <div key={s.key}>
                  <p className="text-sm font-semibold">{s.title} {!s.changed && <span className="caption">unchanged</span>}</p>
                  {s.changed && <p className="mt-1 text-sm leading-relaxed">{s.ops.map((o, i) => <span key={i} className={o.op === "added" ? "bg-green-100 text-green-900" : o.op === "removed" ? "bg-red-100 text-red-800 line-through" : ""}>{o.text} </span>)}</p>}
                </div>
              ))}
            </div>
          </>
        )}
      </section>
    </div>
  );
}
